export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14010.63dfb692.jpg";